//check if value is not defined or null
const formatNumber = (val) => {
    return val ? val.toFixed() : null;
};

//format speed at impact value
export const formatSpeedAtImpact = (val) => {
    return localStorage.selectedUnitType === 'Metric' ?
        formatNumber(val) !== null ?
        formatNumber(val) + ' kph' :
        'na' :
        formatNumber(val) !== 'na' ?
        formatNumber(val / 1.609244) + ' mph' :
        'na';
};

//format accelaration value
export const formatAccelaration = (val) => {
    return localStorage.selectedUnitType === 'Metric' ?
        formatNumber(val) !== null ?
        formatNumber(val) + ' m/s2' :
        'na' :
        formatNumber(val) !== null ?
        formatNumber(val / 3.28084) + ' ft/s2' :
        'na';
};

//format deltaV value
const formatDeltaV = (val) => {
    return localStorage.selectedUnitType === 'Metric' ?
        formatNumber(val) !== null ?
        formatNumber(val) + ' m/s' :
        'na' :
        formatNumber(val) !== null ?
        formatNumber(val * 3.281) + ' ft/s' :
        'na';
};

//format speeding distance value
const formatSpeedingDistance = (val) => {
    return localStorage.selectedUnitType === 'Metric' ?
        formatNumber(val) !== null ?
        formatNumber(val * 1000) + ' m' :
        'na' :
        formatNumber(val) !== null ?
        formatNumber(val * 3.281 * 1000) + ' ft' :
        'na';
};

//format speed limit value
export const formatSpeedLimit = (val) => {
    return localStorage.selectedUnitType === 'Metric' ?
        formatNumber(val) !== null ?
        formatNumber(val) + ' kph' :
        'na' :
        formatNumber(val) !== null ?
        formatNumber(val / 1.609) + ' mph' :
        'na';
};

//format temprature value
const formatTemperature = (val) => {
    return localStorage.selectedUnitType === 'Metric' ?
        formatNumber(val) !== null ?
        formatNumber(val) + ' ° C' :
        'na' :
        formatNumber(val) !== null ?
        formatNumber(val / 9 / 5 + 32) + ' ° F' :
        'na';
};

//format percipitation value
const formatPrecipitation = (val) => {
    return localStorage.selectedUnitType === 'Metric' ?
        formatNumber(val) !== null ?
        formatNumber(val) + ' mm' :
        'na' :
        formatNumber(val) !== null ?
        formatNumber(val / 25.4) + ' inches' :
        'na';
};

//format Visibility value
const formatVisibility = (val) => {
    return localStorage.selectedUnitType === 'Metric' ?
        formatNumber(val) !== null ?
        formatNumber(val) + ' km' :
        'na' :
        formatNumber(val) !== null ?
        formatNumber(val / 1.609) + ' miles' :
        'na';
};

// return object of units based on Metric and Imperial
export const getDataUnit = (data) => {
    return {
        speedAtImpact: formatSpeedAtImpact(data.crashEvent.speedAtImpact),
        deltaV: formatDeltaV(data.crashEvent.deltaV),
        speedingDistance: formatSpeedingDistance(data.speedingDistance),
        speedLimit: formatSpeedLimit(data.crashEvent.speedLimit),
        temperature: formatTemperature(
            data.weatherData[data.weatherData.length - 1].temperature
        ),
        precipitation: formatPrecipitation(
            data.weatherData[data.weatherData.length - 1].precipitation
        ),
        visibility: formatVisibility(
            data.weatherData[data.weatherData.length - 1].visibility
        ),
    };
};